import { InjectionToken } from '@angular/core';

export const BUILD_NO = new InjectionToken<number>('Build number timestamp.');
